export default __webpack_public_path__ + "static/22-ab7951cdb74b0527890673a4c8a450f5.jpg";